import Swiper from '../libs/swiper.min';
//import Plyr from '../libs/plyr.min';

// Make sure $dependencyManager is defined or imported
var $dependencyManager = window.$dependencyManager || window.dependencyManager || $dependencyManager;
export default function initHoverVideoSlider() {
  //$dependencyManager.addDependenciesCallback(['hls', 'plyr'], () => {
  var $ = window.jQuery;
  var sliderSelector = '.mad-slider__container--hover-video';
  //console.log('initHoverVideoSlider()');
  $(sliderSelector).each(function () {
    var $container = $(this);
    var $slidesContainer = $container.find('.mad-slider__slides-container');
    var $slides = $container.find('.mad-slider__slide');

    // Swiper initialization
    var swiper = new Swiper($slidesContainer[0], {
      direction: 'horizontal',
      loop: false,
      speed: 500,
      pagination: {
        el: $container.find('.swiper-pagination')[0],
        clickable: true
      },
      navigation: {
        nextEl: $container.find('.mad-slider__button-next')[0],
        prevEl: $container.find('.mad-slider__button-prev')[0]
      },
      slidesPerView: 'auto',
      spaceBetween: 10,
      updateOnWindowResize: true,
      freeMode: true,
      shortSwipes: false,
      longSwipes: false
    });

    // Video hover logic
    $slides.hover(function () {
      var $video = $(this).find('.mad-hover-video__video');
      var $thumbnailOverlay = $(this).find('.mad-hover-video__thumbnail-overlay');
      $thumbnailOverlay.stop().fadeTo(400, 0);
      var $btnReadMore = $video.find('.mad-hover-video__btn-read-more');
      if ($btnReadMore.length) {
        $btnReadMore.css('opacity', 1);
      }
      var videoSrc = $video.data('src');
      if (!videoSrc) return;
      pauseAllVideos();
      playVideo($video, videoSrc);
    }, function () {
      var $video = $(this).find('.mad-hover-video__video');
      var $thumbnailOverlay = $(this).find('.mad-hover-video__thumbnail-overlay');
      $thumbnailOverlay.stop().fadeTo(400, 1);
      var videoSrc = $video.data('src');
      if (!videoSrc) return;
      var $btnReadMore = $video.find('.mad-hover-video__btn-read-more');
      if ($btnReadMore.length) {
        $btnReadMore.css('opacity', 0);
      }
      pauseVideo($video, videoSrc);
    });

    // Mobile: fade out thumbnail overlay on click
    $slides.on('click', function (e) {
      if (window.matchMedia('(hover: none)').matches) {
        var $thumbnailOverlay = $(this).find('.mad-hover-video__thumbnail-overlay');
        $thumbnailOverlay.stop().fadeTo(400, 0);
      }
    });

    // Click logic for PDF button
    $slides.on('click', '.mad-hover-video__btn-read-more', function (e) {
      var $slide = $(this).closest('.mad-slider__slide');
      var $link = $slide.find('.mad-hover-video__link');
      var href = $link.attr('href');
      if (href) {
        window.open(href, '_blank');
      }
      e.stopPropagation();
    });

    // Play/pause helpers
    function playVideo($video, videoSrc) {
      $video.prop('muted', true);
      $video.attr('muted', 'muted');
      $video[0].volume = 0;
      if (videoSrc.endsWith('.mp4')) {
        if ($video.attr('src') !== videoSrc) {
          $video.attr('src', videoSrc);
        }
        $video[0].play()["catch"](function () {});
      } else if (videoSrc.endsWith('.m3u8')) {
        if (!$video.data('player')) {
          var player = new Plyr($video[0], {
            controls: [],
            muted: true,
            autoplay: false,
            loop: {
              active: true
            },
            fullscreen: {
              enabled: false
            },
            playsinline: true,
            storage: {
              enabled: false
            }
          });
          $video.data('player', player);
          player.volume = 0;
          if (window.Hls && window.Hls.isSupported()) {
            var hls = new window.Hls();
            hls.loadSource(videoSrc);
            hls.attachMedia($video[0]);
            hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
              player.play()["catch"](function () {});
            });
            $video.data('hls', hls);
          } else if ($video[0].canPlayType('application/vnd.apple.mpegurl')) {
            $video[0].src = videoSrc;
            $video.on('canplay', function () {
              $video[0].play()["catch"](function () {});
            });
          }
        } else {
          var _player = $video.data('player');
          _player.play()["catch"](function () {});
        }
      }
    }
    function pauseVideo($video, videoSrc) {
      if (videoSrc.endsWith('.mp4')) {
        $video[0].pause();
      } else if (videoSrc.endsWith('.m3u8')) {
        var player = $video.data('player');
        if (player) {
          player.pause();
        }
      }
    }
    function pauseAllVideos() {
      $slides.each(function () {
        var $video = $(this).find('.mad-hover-video__video');
        var videoSrc = $video.data('src');
        if (videoSrc) {
          pauseVideo($video, videoSrc);
        }
      });
    }
  });
  //})
}